import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class DoublePrevention {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // -------- ▼ 风险分级管控清单 ▼ --------
  // 分页查询所有数据
  public getRiskControlInventory(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventory';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getRiskControlInventoryDetail(id: any) {
    const url = serverUrl + '/api/yunnan/riskControlInventory/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改数据
  public modifyRiskControlInventory(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventory';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 新增数据
  public addRiskControlInventory(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventory';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 删除数据
  public deleteRiskControlInventory(id: any) {
    const url = serverUrl + '/api/yunnan/riskControlInventory?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }
  // 风险风级管控 审批 --> 列表
  public getApprovalRiskControlInventoryList(opts: any) {
    const url = serverUrl + '/api/yunnan/approval/page';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 风险风级管控 审批 --> 删除
  public delApprovalRiskControlInventoryData(id: any) {
    const url = serverUrl + `/api/yunnan/approval/delete/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }
  // 风险风级管控 审批 --> 详情
  public infoApprovalRiskControlInventoryData(id: any) {
    const url = serverUrl + `/api/yunnan/approval/findById/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 风险风级管控 审批 --> 审批 通过
  public approvalRiskControlInventoryHandle(opts: any) {
    const url = serverUrl + `/api/yunnan/approval/pass`;
    return this.rSerivce.serverObj.put(url, opts);
  }
  // 风险风级管控 审批 --> 审批 不通过
  public approvalRiskControlInventoryNoPass(opts: any) {
    const url = serverUrl + `/api/yunnan/approval/noPass`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 通过所在区域获取风险点和危险源
  public getRiskAll(opts: object) {
    const url = serverUrl + '/api/yunnan/riskPointDangerSource/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 查询所有数据
  public getRiskControlInventoryHazardAll(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventoryHazard/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 预处理后的导入数据
  public importRiskControlInventoryDataSave(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventory/canBeImported/export/excel/after/save';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // -------- ▲ 风险分级管控清单 ▲ --------

  //  -------- ▼ 隐患排查清单的接口 ▼ --------
  // 分页查询所有数据
  public getRiskControlInventoryHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventoryHazard';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getRiskControlInventoryHazardDetail(id: any) {
    const url = serverUrl + '/api/yunnan/riskControlInventoryHazard/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改数据
  public modifyRiskControlInventoryHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventoryHazard';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 新增数据
  public addRiskControlInventoryHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/riskControlInventoryHazard';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 删除数据
  public deleteRiskControlInventoryHazard(id: any) {
    const url = serverUrl + '/api/yunnan/riskControlInventoryHazard?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  //  -------- ▲ 隐患排查清单的接口 ▲ --------

  // -------- ▼ 风险点危险源管理 ▼ --------
  // 分页查询所有数据
  public getRiskPointDangerSource(opts: any) {
    const url = serverUrl + '/api/yunnan/riskPointDangerSource';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 删除数据
  public deleteRiskPointDangerSource(id: any) {
    const url = serverUrl + '/api/yunnan/riskPointDangerSource?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 新增数据
  public addRiskPointDangerSource(opts: any) {
    const url = serverUrl + '/api/yunnan/riskPointDangerSource';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editRiskPointDangerSource(opts: any) {
    const url = serverUrl + '/api/yunnan/riskPointDangerSource';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 积分配置
  public getPointConfig(opts: any) {
    const url = serverUrl + '/api/spaceManage/credit/config';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 修改积分配置
  public editPointConfig(opts: any) {
    const url = serverUrl + `/api/spaceManage/credit/config`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  //  -------- ▲ 风险点危险源管理 ▲ --------

  // 根据巡检任务点id获取未保存的详情
  public getPatrolHazardCheckShellDetail(patrolTaskPointId: any) {
    const url = serverUrl + '/api/yunnan/patrolHazardCheck/shell/' + patrolTaskPointId;
    return this.rSerivce.serverObj.get(url);
  }
  // 根据巡检任务点 编辑图片
  public getPatrolHazardImage(opts: any) {
    const url = serverUrl + '/api/yunnan/patrolHazardCheck/edit ';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 【设备巡检】根据设备巡检任务明细的id获取未保存的详情
  public getPatrolHazardCheckShellDetail1(patrolTaskPointId: any) {
    const url = serverUrl + '/api/yunnan/patrolHazardCheck/device/shell/' + patrolTaskPointId;
    return this.rSerivce.serverObj.get(url);
  }

  // -------- ▼ 应急资源模块用到的接口 ▼ --------
  /*                 队伍管理                 */

  // 分页查询所有数据
  public getEmergencyContingent(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyContingent';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getSingleEmergencyContingentData(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyContingent/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addEmergencyContingent(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyContingent';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editEmergencyContingent(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyContingent';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deleteEmergencyContingent(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyContingent?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  /*                 队伍管理                 */

  /*                 应急演练记录                 */

  // 分页查询所有数据
  public getEmergencyDrillRecord(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyDrillRecord';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getSingleEmergencyDrillRecord(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyDrillRecord/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addEmergencyDrillRecord(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyDrillRecord';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editEmergencyDrillRecord(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyDrillRecord';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deleteEmergencyDrillRecord(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyDrillRecord?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }
  // 记录 汇总表
  public getEmergencyDrillRecordsStatisticsData(opts: any) {
    const url = serverUrl + '/api/yunnan/emergencyDrillRecord/statistics';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 演练计划 --- 查询所有数据
  public getPlanAll() {
    const url = serverUrl + '/api/yunnan/emergencyDrillPlan/all';
    return this.rSerivce.serverObj.get(url);
  }

  /*                 应急演练记录                 */

  /*                 应急演练计划                 */

  // 分页查询所有数据
  public getEmergencyDrillPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyDrillPlan';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 所有 数据
  public getEmergencyDrillPlanAll(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyPlan/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getSingleEmergencyDrillPland(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyDrillPlan/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addEmergencyDrillPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyDrillPlan';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editEmergencyDrillPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyDrillPlan';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deleteEmergencyDrillPlan(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyDrillPlan?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }
  // 查询年度开展情况
  public getEmergencyStatistics(opts: any) {
    const url = serverUrl + '/api/yunnan/emergency/statistics/planReport';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  /*                 应急演练计划                 */

  /*                 预案管理                 */

  // 分页查询所有数据
  public getEmergencyPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyPlan';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getSingleEmergencyPlan(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyPlan/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addEmergencyPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyPlan';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editEmergencyPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyPlan';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deleteEmergencyPlan(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyPlan?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  /*                 预案管理                 */

  /*                 物资装备                 */

  // 分页查询所有数据
  public getEmergencyMaterials(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyMaterials';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getSingleEmergencyMaterials(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyMaterials/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addEmergencyMaterials(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyMaterials';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editEmergencyMaterials(opts: object) {
    const url = serverUrl + '/api/yunnan/emergencyMaterials';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deleteEmergencyMaterials(id: any) {
    const url = serverUrl + '/api/yunnan/emergencyMaterials?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 下载模版 /api/yunnan/emergencyMaterials/download/import/stencil
  public downResultPdf = (id: any) => {
    return this.rSerivce.serverObj({
      // url: `/executionResult/downloadPdf/${id}`,
      url: `${serverUrl}/api/yunnan/emergencyMaterials/download/import/stencil`,
      method: 'get',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', //请求头 根据实际接口文档内容填写
      },
      responseType: 'blob', //默认json，设置成blob
    });
  };
  /*                 物资装备                 */

  //  -------- ▲ 应急资源模块用到的接口 ▲ --------

  // -------- ▼ 隐患部门配置 ▼ --------
  // 查询所有数据
  public getHazardLevelDepartmentConfigAll() {
    const url = serverUrl + '/api/yunnan/hazardLevelDepartmentConfig/all';
    return this.rSerivce.serverObj.get(url);
  }

  // 通过主键查询单条数据
  public getHazardLevelDepartmentConfigDetail(opts: any) {
    const url = serverUrl + '/api/yunnan/hazardLevelDepartmentConfig/details';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 修改数据
  public modifyHazardLevelDepartmentConfig(opts: object) {
    const url = serverUrl + '/api/yunnan/hazardLevelDepartmentConfig';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // -------- ▲ 隐患部门配置 ▲ --------

  // -------- ▼ 风险随查 历史▼ --------
  // 分页数据
  public getHandyCheckList(opts: object) {
    const url = serverUrl + '/api/yunnan/handyCheck';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 通过主键查询单条数据
  public getHandyCheckDetail(id: string) {
    const url = serverUrl + `/api/yunnan/handyCheck/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 删除数据
  public deleteHandyCheck(id: any) {
    const url = serverUrl + '/api/yunnan/handyCheck?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }
  //  -------- ▲ 风险随查  历史▲ --------
  //  -------- ▼ 企业应急预案▼ --------
  // 分页数据
  public getEnterpriseEmergencyPlanList(opts: object) {
    const url = serverUrl + '/api/yunnan/enterpriseEmergencyPlan';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addEnterpriseEmergencyPlan(opts: object) {
    const url = serverUrl + '/api/yunnan/enterpriseEmergencyPlan';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editEnterpriseEmergencyPlan(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/enterpriseEmergencyPlan/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 通过主键查询单条数据
  public getSingleEnterpriseEmergencyPlan(id: string) {
    const url = serverUrl + `/api/yunnan/enterpriseEmergencyPlan/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 删除数据
  public deleteEnterpriseEmergencyPlan(id: any) {
    const url = serverUrl + '/api/yunnan/enterpriseEmergencyPlan/' + id;
    return this.rSerivce.serverObj.delete(url);
  }
  //  -------- ▲ 企业应急预案▲ --------
}
